import { configureStore } from '@reduxjs/toolkit';

import authSlice from './auth/authSlice';
import sidebarSlice from './sidebar/sidebarSlice';

import cartSlice from "./cart/cartSlice";

import notificationsSlice from "./notifications/notificationsSlice";
// dashboard slices
import statisticsSlice from './dashboard/statisticsSlice';

import rolesSlice from './rules/rulesSlice';
import categoriesSlice from './categories/categoriesSlice';
import shippingCompaniesSlice from './shippingCompanies/shippingCompaniesSlice';
import priceListSlice from './priceList/priceListSlice';

import usersSlice from './users/usersSlice';
import moderatorsSlice from './moderators/moderatorsSlice';
import warehousesSlice from './warehouses/warehousesSlice';
import productsSlice from './products/productsSlice';
import ordersSlice from './orders/ordersSlice';
import accountsSlice from './accounts/accountsSlice';
import requestsSlice from './requests/requestsSlice';

import supportsSlice from "./supports/supportsSlice";

import serversSlice from "./servers/serversSlice";
import talentsSlice from "./talents/talentsSlice";
import videosSlice from "./videos/videosSlice";
import contentCreatorsSlice from "./contentCreators/contentCreatorsSlice";
import shopItemsSlice from "./shopItems/shopItemsSlice";
import shopItemOffersSlice from "./shopItemOffers/shopItemOffersSlice";
import servicesSlice from "./services/servicesSlice";
import commentsSlice from "./comments/commentsSlice";
import siteVisitSlice from "./siteVisit/siteVisitSlice";
import settingsSlice from "./settings/settingsSlice";
import walletSlice from "./wallet/walletSlice";

export default configureStore({
  reducer: {
    cart: cartSlice,
    sidebar: sidebarSlice,
    notifications: notificationsSlice,
    statistics: statisticsSlice,
    roles: rolesSlice,
    categories: categoriesSlice,
    shippingCompanies: shippingCompaniesSlice,
    priceList: priceListSlice,
    auth: authSlice,
    users: usersSlice,
    moderators: moderatorsSlice,
    warehouses: warehousesSlice,
    products: productsSlice,
    orders: ordersSlice,
    accounts: accountsSlice,
    requests: requestsSlice,
    supports: supportsSlice,
    servers: serversSlice,
    talents: talentsSlice,
    videos: videosSlice,
    contentCreators: contentCreatorsSlice,
    shopItems: shopItemsSlice,
    shopItemOffers: shopItemOffersSlice,
    services: servicesSlice,
    comments: commentsSlice,
    siteVisit: siteVisitSlice,
    settings: settingsSlice,
    wallet: walletSlice,
  },
});